import { Component, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { EmployeeDataTableService } from 'src/app/views/employee-data-table/employee-data-table.service';
import { SelectionModel } from '@angular/cdk/collections'
import { ToastrService } from 'ngx-toastr';
import { debug, log } from 'console';
import { PageEvent } from '@angular/material/paginator';
import { throttle } from '@swimlane/ngx-charts';
@Component({
  selector: 'app-training-skills',
  templateUrl: './training-skills.component.html',
  styleUrls: ['./training-skills.component.css']
})
export class TrainingSkillsComponent {

  selection = new SelectionModel<any>(true, []);
  selectedIds = [];

  displayedColumns = ["select", "employeeId", "firstName", "lastName", "email", 'primarySkillsData'];
  loading: boolean = true;
  searchText: string = "";
  roleFilter: string = "";
  isProfileCompleted: boolean = true;
  from: any = 0;
  size: any = 10;
  totalRecords: any = 0;
  currentPage: Number = 0;
  totalCertificates: Number;
  public dataSource: MatTableDataSource<any>;
  public profileCompletedCounts: any;
  @ViewChild(MatSort) sort: MatSort;
  compId: number;
  serviceAreaId: number;
  skills: any[] = [];
  proficiency: any[] = [
    {
      key: 1,
      value: 'Beginner'
    }, {
      key: 2,
      value: 'Intermediate'
    }, {
      key: 3,
      value: 'Expert'
    }];
  isDisabled = false;
  proficiencyId: number = 1;
  skillId: string[];
  PageIndex = 1;
  isAllSelected: boolean = false;
  constructor(private service: EmployeeDataTableService, public toaster: ToastrService) {
  }
  selectedRows: any[] = [];

  ngOnInit() {

    this.compId = Number(sessionStorage.getItem("compId"));
    this.serviceAreaId = Number(sessionStorage.getItem("SubcompId"));
    this.getSkills();

  }
  searchTerm: string = '';

  onValueChange(): void {
    this.dataSource.filter = this.searchTerm.trim().toLowerCase();
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      return data.primarySkillsData.toLowerCase().includes(filter) || data.firstName.toLowerCase().includes(filter) || data.lastName.toLowerCase().includes(filter) || data.email.toLowerCase().includes(filter) || data.employeeId.toString().toLowerCase().includes(filter);
    };

    } 
    
  storeSelectedIds(row: any, event?: any) {
    row.isChecked = event;
    if (event) {
      if (!this.selectedIds.some(item => item.employeeId === row.employeeId)) {

        this.selectedIds.push({ employeeId: row.employeeId, EmpMail: row.email });
      }
      this.isAllSelected = this.dataSource.data.every((row: any) => this.selectedIds.some(item => item.employeeId === row.employeeId));
    }
    else {
      this.selectedIds = this.selectedIds.filter(item => item.employeeId !== row.employeeId);
      this.isAllSelected = false;
    }
  }

  masterToggle(event: any) {
    if (event) {
      this.isAllSelected = true;
      this.dataSource.data.forEach((row: any) => {
        this.selectedIds.push({ employeeId: row.employeeId, EmpMail: row.email });
        row.isChecked = true;
      });
    }
    else {
      this.isAllSelected = false;
      this.dataSource.data.forEach((row: any) => {
        this.selectedIds = this.selectedIds.filter(item => item.employeeId !== row.employeeId);
        row.isChecked = false;
      });
    }
  }

  isIndeterminate() {
    return  this.dataSource.data.some((row: any) => this.selectedIds.some(item => item.employeeId === row.employeeId)) && !this.isAllSelected;
  }

  getSkills() {

    this.service.getSkillsByCompetencyAndServiceLine(this.compId, this.serviceAreaId).subscribe(res => {
      this.skills = res.data;
      this.getEmployeeData();
    })
  }
  getEmployeeData() {

    this.loading = true;
    let serviceAreaSkill = {
      competencyId: this.compId,
      proficiency: this.proficiencyId,
      skills: this.skills.map(skillObj => skillObj.skill) ?? [],
      from: this.from,
      size: this.size
    }
    return this.service.getEmployeesBySkillCriteria(serviceAreaSkill).subscribe(x => {
      let dataItems = x.data.items;
      if (dataItems && dataItems.length > 0) {
        dataItems.forEach(e => {
          e.primarySkillsData = e.primarySkills.map(s => s.skill).join(',');
        });
      }
      this.dataSource = new MatTableDataSource(dataItems);
      this.dataSource.sort = this.sort;
      this.totalRecords = x.data.total;

      this.dataSource.data.forEach(row => {
        if (this.selectedIds.some(item => item.employeeId === row.employeeId)) {
          row.isChecked = true;

        }
      });
      this.isAllSelected = this.dataSource.data.every((row: any) => this.selectedIds.some(item => item.employeeId === row.employeeId));
      this.loading = false;

    });
  }
  getPaginatorData(event) {
    if (event.previousPageIndex > event.pageIndex) {
      this.from = (event.pageIndex * this.size);
      this.size = event.pageSize;
    }
    else {
      this.size = event.pageSize;
      this.from = (event.pageIndex * this.size);
    }
    this.getEmployeeData();
  }
  onProficiencyChange(value: any) {
    this.proficiencyId = value;
    this.getEmployeeData();
  }
  onSkillChange(value: any) {
    this.skillId = [value];
    this.getEmployeeData();
  }

  initiateTraining() {

    this.toaster.clear();
    console.log("Selected Ids : ", this.selectedIds);
    this.selectedIds.forEach(id => {

    })
    if (this.selectedIds.length > 0) {
      //initiate training

    } else {
      this.toaster.error(`Please select at least one employee to initiate training.`);
      return false;
    }
  }

}
